import { VStack } from '@genial/components';
import { Spacing } from '@genial/design-tokens';
import { View } from 'native-base';
import React from 'react';

import { CockpitSectionBlockingMismatchedPartner } from '../Cockpit/components/CockpitSectionBlockingMismatchedPartner';

import { Header } from './components/Header';
import { SectionWrapper } from './components/SectionWrapper';
import { Table } from './components/Table';
import { useBatchTicketRequests } from './hooks';

interface BatchTicketRequestsProps {}

export const BatchTicketRequests: React.FC<BatchTicketRequestsProps> = () => {
  const { isLoading, isLoadingMore, refresher, response, skeletonItemCount, error, onEndReached } =
    useBatchTicketRequests();
  return (
    <View minW="container">
      <VStack space={Spacing['inline.xxs']} flex={1} px={Spacing['inline.xxxs']}>
        <Header />
        <SectionWrapper
          refresher={refresher}
          table={
            <Table
              isLoading={isLoading}
              isLoadingMore={isLoadingMore}
              refresher={refresher}
              response={response}
              skeletonItemCount={skeletonItemCount}
              error={error}
              onEndReached={onEndReached}
            />
          }
        />
      </VStack>
      <CockpitSectionBlockingMismatchedPartner />
    </View>
  );
};
